module.exports = __webpack_public_path__ + "static/media/hotel-banner.a2adcb3c.jpg";